import * as Yup from 'yup'

import { FORMIK_EMPTY_VALUE } from '../../../../../../constants/validation'
import { parseAmount } from '../../../../../../utils/number'
import { formValidationSchemaNoChanged } from '../../../../../Form'
import {
  getIsListingAmountWithinMax,
  getListingAmountMaxErrorText,
  LISTING_FORM_DEPOSIT_TEXT_MAX_LENGTH,
  LISTING_FORM_FIELD_NAME_DEPOSIT_AMOUNT,
  LISTING_FORM_FIELD_NAME_DEPOSIT_TEXT,
  LISTING_FORM_FIELD_NAME_RENT_PRICE,
  LISTING_FORM_FIELD_NAME_SERVICE_CHARGE,
} from '../../../../../RentalPortalListing'

import {
  LISTING_PROFILE_KEY_FACTS_FIELD_NAME_HEATING_COSTS,
  LISTING_PROFILE_KEY_FACTS_FIELD_NAME_HEATING_COSTS_INCLUDED,
  LISTING_PROFILE_KEY_FACTS_FIELD_NAME_OTHER_COSTS,
} from './RentalPortalListingProfileKeyFactsWidget.constants'

function getListingKeyFactsAmountValue(value) {
  return value == null ? FORMIK_EMPTY_VALUE : String(value)
}

function getListingKeyFactsCostSchema(t) {
  return Yup.string()
    .ensure()
    .test(
      'nonNegative',
      t('Error.EnterPositiveNumberKey'),
      value => !value || parseAmount(value) >= 0
    )
    .test('max', getListingAmountMaxErrorText(t), getIsListingAmountWithinMax)
}

function getListingKeyFactsAmountPayloadValue(value) {
  return value ? parseAmount(value) : null
}

export function getListingKeyFactsInitialValues(listing) {
  return {
    [LISTING_FORM_FIELD_NAME_DEPOSIT_AMOUNT]: getListingKeyFactsAmountValue(
      listing?.deposit_amount
    ),
    [LISTING_FORM_FIELD_NAME_DEPOSIT_TEXT]:
      listing?.deposit_text ?? FORMIK_EMPTY_VALUE,
    [LISTING_FORM_FIELD_NAME_RENT_PRICE]: getListingKeyFactsAmountValue(
      listing?.rent_price
    ),
    [LISTING_FORM_FIELD_NAME_SERVICE_CHARGE]: getListingKeyFactsAmountValue(
      listing?.service_charge
    ),
    [LISTING_PROFILE_KEY_FACTS_FIELD_NAME_HEATING_COSTS]:
      getListingKeyFactsAmountValue(listing?.heating_costs),
    [LISTING_PROFILE_KEY_FACTS_FIELD_NAME_HEATING_COSTS_INCLUDED]: Boolean(
      listing?.heating_costs_included
    ),
    [LISTING_PROFILE_KEY_FACTS_FIELD_NAME_OTHER_COSTS]:
      getListingKeyFactsAmountValue(listing?.other_costs),
  }
}

export function getListingKeyFactsValidationSchema({ initialValues, t }) {
  return Yup.object({
    [LISTING_FORM_FIELD_NAME_DEPOSIT_AMOUNT]: getListingKeyFactsCostSchema(t),
    [LISTING_FORM_FIELD_NAME_DEPOSIT_TEXT]: Yup.string()
      .ensure()
      .max(LISTING_FORM_DEPOSIT_TEXT_MAX_LENGTH, true),
    [LISTING_FORM_FIELD_NAME_RENT_PRICE]: Yup.string()
      .ensure()
      .test(
        'positive',
        t('RentalPortal.ListingRentPositiveErrorKey'),
        value => !value || parseAmount(value) > 0
      )
      .test(
        'max',
        getListingAmountMaxErrorText(t),
        getIsListingAmountWithinMax
      ),
    [LISTING_FORM_FIELD_NAME_SERVICE_CHARGE]: getListingKeyFactsCostSchema(t),
    [LISTING_PROFILE_KEY_FACTS_FIELD_NAME_HEATING_COSTS]:
      getListingKeyFactsCostSchema(t),
    [LISTING_PROFILE_KEY_FACTS_FIELD_NAME_OTHER_COSTS]:
      getListingKeyFactsCostSchema(t),
  }).concat(formValidationSchemaNoChanged({ initialValues }))
}

export function getListingKeyFactsPatchPayload(values) {
  return {
    deposit_amount: getListingKeyFactsAmountPayloadValue(
      values[LISTING_FORM_FIELD_NAME_DEPOSIT_AMOUNT]
    ),
    deposit_text: values[LISTING_FORM_FIELD_NAME_DEPOSIT_TEXT],
    heating_costs: getListingKeyFactsAmountPayloadValue(
      values[LISTING_PROFILE_KEY_FACTS_FIELD_NAME_HEATING_COSTS]
    ),
    heating_costs_included:
      values[LISTING_PROFILE_KEY_FACTS_FIELD_NAME_HEATING_COSTS_INCLUDED],
    other_costs: getListingKeyFactsAmountPayloadValue(
      values[LISTING_PROFILE_KEY_FACTS_FIELD_NAME_OTHER_COSTS]
    ),
    rent_price: getListingKeyFactsAmountPayloadValue(
      values[LISTING_FORM_FIELD_NAME_RENT_PRICE]
    ),
    service_charge: getListingKeyFactsAmountPayloadValue(
      values[LISTING_FORM_FIELD_NAME_SERVICE_CHARGE]
    ),
  }
}
